
import { SubjectType } from "../types";
import { HISTORY_CHRONOLOGY } from "./history/chronology";
import { TURKISH_HIERARCHY } from "./turkish/hierarchy";
import { EXAM_BLUEPRINTS } from "./topicDistributions";

// TOPICS_BY_SUBJECT: History ve Turkish için hiyerarşik alt konulardan,
// diğer dersler için EXAM_BLUEPRINTS'ten türetilir.
export const TOPICS_BY_SUBJECT: Record<SubjectType, string[]> = {
    geography: EXAM_BLUEPRINTS.geography.map(t => t.topic),
    history: HISTORY_CHRONOLOGY.flatMap(unit => unit.subTopics),
    citizenship: EXAM_BLUEPRINTS.citizenship.map(t => t.topic),
    turkish: TURKISH_HIERARCHY.flatMap(unit => unit.subTopics),
    math: EXAM_BLUEPRINTS.math.map(t => t.topic),
};

export const geminiTopics = TOPICS_BY_SUBJECT['geography']; // Default fallback
